import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { PUB_TAG } from '../analytics/PublisherTagsService'
import { RI_CLIC_ITI, TAG_MULTIPATH_CTA } from '../analytics/analytics.tagids.constants'
import { getColor } from '../../store/itinerary/itinerary.selectors'
import TagActionLink from '../genericComponents/TagActionLink'
import classNames from 'classnames'
import { buildStyleAttributes } from '../utils/css'

import s from './ProviderCTAButton.less'
import ItineraryButtonContainer from './ItineraryButtonContainer'
import TagActionButton from '../genericComponents/TagActionButton'
import { CLICKED_BUTTON } from '../analytics/analytics.constants'

const ProviderCTAButton = ({ elementRef, ctaData, route, placement, className }) => {
  const color = useSelector(getColor)

  const [style, setStyle] = useState()

  const buildStyle = color =>
    color &&
    setStyle(
      buildStyleAttributes({
        backgroundColor: color,
        borderColor: color,
        color: 'white'
      })
    )

  useEffect(() => buildStyle(color), [color])

  const handleMouseOut = useCallback(() => buildStyle(color), [color])

  const handleMouseEnter = useCallback(
    () =>
      color &&
      setStyle(
        buildStyleAttributes({
          backgroundColor: 'white',
          borderColor: color,
          color
        })
      ),
    [color]
  )

  const data = ctaData || route

  if (!data) return <></>

  return (
    <ItineraryButtonContainer className={className}>
      <TagActionButton type={RI_CLIC_ITI} key={data.routeId}>
        <TagActionLink
          elementRef={elementRef}
          className={classNames(s.ProviderCTAButton, { [s.ProviderCTAButtonDefault]: !color })}
          href={data.ctaLink}
          targetBlank={true}
          nofollow={true}
          tagInfo={{ provider: data.provider, tag: PUB_TAG.PUB_MULTIPATH_GOTO, placement }}
          type={TAG_MULTIPATH_CTA}
          style={style}
          mouseEnter={handleMouseEnter}
          mouseOut={handleMouseOut}
          dataset={{ [CLICKED_BUTTON]: data.actionLabel }}
        >
          {data.actionLabel}
        </TagActionLink>
      </TagActionButton>
    </ItineraryButtonContainer>
  )
}

export default ProviderCTAButton
